module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Folder-3a158764af0928db92a582281ae542cb.svg";